import React, {Component} from 'react';
import { Redirect } from 'react-router';

export default class RedirectToPNFView extends Component {
   render() {
      const {location}= this.props;
      const currentLocation = location.pathname;
      return (
         <Redirect to={{
            pathname: '/pageNotFound',
            state: { referrer: currentLocation }
         }}/>
      );
   }
}



// WEBPACK FOOTER //
// ./src/views/RedirectToPNFView.js